<template>
  <v-card>
    <v-toolbar :style="styles" dark flat>
      <v-toolbar-title class="white--text text-center"
        >Share your library</v-toolbar-title
      >
      <template v-slot:extension>
        <v-overlay absolute style="background: rgba(0, 0, 0, 0.2); width: 100%">
          Give viewers access to your entire portal library
        </v-overlay>
      </template>
    </v-toolbar>

    <v-container style="height: 450px; overflow-y: auto">
      <v-row justify="center" align="center">
        <v-col cols="9">
          <v-text-field
            readonly
            label="Library logo"
            @click="selectFile"
            hide-details
            :placeholder="share_link.logo ? share_link.logo.name : ''"
          ></v-text-field>
        </v-col>
        <v-col cols="3" class="text-center">
          <input
            type="file"
            style="display: none"
            ref="filepicker"
            @change="handleFileChange($event)"
            accept="image/*"
          />
          <v-btn
            :loading="uploading_logo"
            fab
            color="blue"
            dark
            @click="selectFile"
          >
            <v-icon>fa-upload</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row justify="center" align="center">
        <v-col class="text-right" cols="9">
          <span class="text--secondary">
            Preview what
            <b>viewers</b> will see
          </span>
        </v-col>
        <v-col class="text-center" cols="3">
          <v-btn fab :href="viewerLink" target="_blank">
            <v-icon>fa-eye</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col cols="9">
          <v-text-field
            label="Link to library"
            outlined
            hide-details
            :value="viewerLink"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3" class="text-center py-0">
          <v-btn fab dark color="green" v-if="copied">
            <span class="caption">Copied</span>
          </v-btn>
          <v-btn
            title="Copy to clipboard"
            fab
            v-else
            v-clipboard:copy="viewerLink"
            v-clipboard:success="onCopy"
            v-clipboard:error="onCopyError"
          >
            <v-icon>fa-paperclip</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col cols="9">
          <v-form
            ref="viewer-access-code-form"
            autocomplete="viewer-access-code"
            lazy-validation
          >
            <v-text-field
              outlined
              label="Access code (optional)"
              v-model="share_link.access_code"
              placeholder="Set an access code for viewers"
              type="text"
              @change="update"
              autocomplete="library-access-code"
              hide-details
              :loading="updating"
            ></v-text-field>
          </v-form>
        </v-col>
        <v-col cols="3" class="text-center">
          <div v-if="saved">
            <v-btn fab dark color="green">
              <span class="caption">Saved</span>
            </v-btn>
          </div>
          <div v-else>
            <v-icon v-if="share_link.access_code">fa-lock</v-icon>
            <v-icon v-else>fa-lock-open</v-icon>
          </div>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col cols="9" class="text-center">
          <v-text-field
            outlined
            label="Send email"
            placeholder="Viewer email address"
            hide-details
            v-model="email"
          ></v-text-field>
        </v-col>
        <v-col cols="3" class="text-center py-0">
          <v-btn fab dark color="green" v-if="sent">
            <span class="caption">Sent</span>
          </v-btn>
          <v-btn fab v-else @click="sendViewer" :loading="sending">
            <v-icon small>fa-paper-plane</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "SharePortals",
  props: ["styles"],
  data() {
    return {
      share_link: {},
      copied: false,
      email: "",
      loading: false,
      uploading_logo: false,
      updating: false,
      sending: false,
      sent: false,
      saved: false,
    };
  },
  created() {
    this.load();
  },
  computed: {
    viewerLink() {
      return this.share_link.uid
        ? `${window.location.origin}/library/${this.share_link.uid}`
        : ``;
    },
  },
  methods: {
    selectFile() {
      this.$refs.filepicker.click();
    },
    handleFileChange(ev) {
      console.log("handleFileChange", ev);
      let file;
      if (ev.target.files) {
        file = ev.target.files[0];
      }
      this.$refs.filepicker.value = null;
      this.uploadLogo(file);
    },
    async uploadLogo(file) {
      this.uploading_logo = true;
      try {
        let form = new FormData();
        form.append("file", file);
        await this.$api.put(
          `/user/portals/share-links/${this.share_link.uid}`,
          form
        );
        this.load();
      } catch (ex) {
        alert(ex.error);
      }
      this.uploading_logo = false;
    },
    async load() {
      this.loading = true;
      try {
        this.share_link = await this.$api.get(`/user/portals/share-links`);
      } catch (ex) {
        alert(ex.error);
      }
      this.loading = false;
    },
    async update() {
      this.updating = true;
      try {
        await this.$api.post(
          `/user/portals/share-links/${this.share_link.uid}`,
          {
            access_code: this.share_link.access_code,
          }
        );
        this.saved = true;
        setTimeout(
          function () {
            this.saved = false;
          }.bind(this),
          1000
        );
      } catch (ex) {
        alert(ex.error);
      }
      this.updating = false;
    },
    async sendViewer() {
      if (!this.email) {
        return alert("Missing viewer email address");
      }
      if (!this.$helpers.validEmail(this.email)) {
        return alert("Invalid viewer email address");
      }
      try {
        this.sending = true;
        await this.$api.post(`/user/invite/library`, {
          email: this.email,
        });
        this.email = "";
        this.sent = true;
        setTimeout(
          function () {
            this.sent = false;
          }.bind(this),
          1000
        );
      } catch (ex) {
        alert(ex.error);
      }
      this.sending = false;
    },
    onCopy: function () {
      this.copied = true;
      setTimeout(
        function () {
          this.copied = false;
        }.bind(this),
        1000
      );
    },
    onCopyError: function () {
      alert("Failed to copy link");
    },
  },
};
</script>

<style>
</style>